import React from "react";
import { useTheme, Typography, Container } from "@mui/material";
import { keyframes } from "@emotion/react";
import useCustomStyles from "../hooks/CustomStylesHook";
import { HOME_CONSTANTS } from "../constants/constants";

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const pulse = keyframes`
    0% {
        transform: scale(1);
        box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
    }
    50% {
        transform: scale(1.05);
        box-shadow: 0 0 20px rgba(255, 255, 255, 0.7);
    }
    100% {
        transform: scale(1);
        box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
    }
`;

const styles = (theme: any) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "90vh",
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main} 100%)`,
    color: "#fff",
    animation: `${fadeIn} 1.5s ease-out`,
    overflow: "hidden",
  },
  title: {
    fontSize: "3rem",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: theme.spacing(2),
    letterSpacing: "0.1rem",
    textShadow: "2px 2px 10px rgba(0, 0, 0, 0.3)",
    animation: `${fadeIn} 2s ease-out`,
  },
  subtitle: {
    fontSize: "1.5rem",
    textAlign: "center",
    marginBottom: theme.spacing(3),
    color: "rgba(255, 255, 255, 0.9)",
    animation: `${fadeIn} 2.5s ease-out`,
  },
  button: {
    marginTop: theme.spacing(2),
    padding: "12px 24px",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.getContrastText(theme.palette.primary.main),
    backgroundColor: theme.palette.primary.light,
    borderRadius: "25px",
    transition: "all 0.3s ease-in-out",
    animation: `${pulse} 2s infinite`,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
      transform: "scale(1.1)",
      boxShadow: "0 0 20px rgba(255, 255, 255, 0.9)",
    },
  },
  glowEffect: {
    position: "absolute",
    width: "300px",
    height: "300px",
    borderRadius: "50%",
    background: `radial-gradient(circle, ${theme.palette.primary.main}, transparent)`,
    filter: "blur(150px)",
    animation: `${fadeIn} 2s ease-out`,
    "&:nth-of-type(1)": {
      top: "10%",
      left: "10%",
    },
    "&:nth-of-type(2)": {
      bottom: "10%",
      right: "10%",
    },
  },
});

const Home: React.FC = () => {
  const theme = useTheme();
  const classes = useCustomStyles(styles, theme);

  return (
    <Container className={classes?.root}>
      <div className={classes?.glowEffect}></div>
      <div className={classes?.glowEffect}></div>
      <Typography variant="h1" className={classes?.title}>
        {HOME_CONSTANTS?.WELCOME_MESSAGE}
      </Typography>
      <Typography variant="h6" className={classes?.subtitle}>
        {HOME_CONSTANTS?.WELCOME_DETAILED_MESSAGE}
      </Typography>
    </Container>
  );
};

export default Home;
